import { render, staticRenderFns } from "./TotalValueDeliveredHome.vue?vue&type=template&id=5c16e666&"
import script from "./TotalValueDeliveredHome.vue?vue&type=script&lang=js&"
export * from "./TotalValueDeliveredHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports